class BAOCustomElement extends HTMLElement {
  _elIdentifier = `data-${this.identifier}-el`
  _externalElIdentifier = `data-${this.identifier}-external-el`
  hasBeenInitialised = false
  /**
   * sections - a list of sections that are related to this element. They can be updated by calling
   * the renderSections method with updated HTML
   * @type {Section[]}
   * @public
   */
  sections = []

  constructor () {
    super()

    /** @type {Object.<{ exists: boolean, elements: HTMLElement[], element: HTMLElement }>} */
    this.els = this.getElements(this._getElementIdentifiers())
    /** @type {Object.<{ exists: boolean, elements: HTMLElement[], element: HTMLElement }>} */
    this.externalEls = this.getElements(
      this._getExternalElementIdentifiers(),
      this._externalElIdentifier,
      { context: document },
    )
    this.listeners = new window.BAOv2.utils.Listeners()

    this.checkValidity()
  }

  connectedCallback () {
    if (this.hasBeenInitialised) return

    this.hasBeenInitialised = true

    this.setupListeners()
  }

  disconnectedCallback () {
    this.listeners.removeAll()
  }

  checkValidity () {}

  raiseError (message) {
    throw new Error(`<${this.localName}>: ${message}`)
  }

  setupListeners () {}

  getElements (identifiers, elementIdentifier = this._elIdentifier, { context = this } = {}) {
    return identifiers.reduce((els, identifier) => {
      const selector =
        this.key && elementIdentifier === this._externalElIdentifier
          ? `[${elementIdentifier}="${identifier}"][key="${this.key}"]`
          : `[${elementIdentifier}="${identifier}"]`
      const elements = Array.from(context.querySelectorAll(selector))

      els[identifier] = {
        exists: elements.length > 0,
        elements,
        element: elements[0],
        selector,
      }

      return els
    }, {})
  }

  _getElementIdentifiers () {
    return Array.from(this.querySelectorAll(`[${this._elIdentifier}]`)).map(el =>
      el.getAttribute(this._elIdentifier),
    )
  }

  _getExternalElementIdentifiers () {
    const selector = this.key
      ? `[${this._externalElIdentifier}][key="${this.key}"]`
      : `[${this._externalElIdentifier}]`

    return Array.from(document.querySelectorAll(selector)).map(el =>
      el.getAttribute(this._externalElIdentifier),
    )
  }

  /**
   * Renders multiple sections based on sections returned from the cart AJAX API
   *
   * @param {object} stateSections - An object where the keys are section ids and the values are
   *   the HTML returned from the section rendering API
   *
   * @returns {void}
   */
  renderSections (stateSections) {
    if (this.sections.length === 0) return

    const sectionsToRender = this.sections
      .filter(s => s.id in stateSections)
      .map(s => Object.assign({}, s, { html: stateSections[s.id] }))

    window.BAOv2.utils.sectionRenderer.renderMultiple(sectionsToRender)
  }

  log (groupName, ...otherItems) {
    if (!this.debug) return

    /* eslint-disable no-console */
    console.group(groupName)

    otherItems.forEach(item => console.log(item))

    console.groupEnd()
    /* eslint-enable no-console */
  }

  get identifier () {
    return this.nodeName.toLowerCase()
  }

  get debug () {
    return window.theme.isDevTheme
  }

  get key () {
    return this.getAttribute('key')
  }
}

window.BAOv2.CustomElement = BAOCustomElement
